function generateBatchName(batchYear) {
  let batchName = "Batch '";
  return batchName + batchYear.substr(batchYear.length - 2, batchYear.length - 1);
}

module.exports = {
  generateBatchName
}